import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {birthdayGiftApi} from "@/container";

/**
 * The birthday gifts of the organization.
 */
const useBirthdayGifts = () => {
    return useSwr(
        cacheKey('birthday-gifts'),
        () => birthdayGiftApi().index()
    );
};

export default useBirthdayGifts;
